import words from 'lodash.words';

export default function countWords(text: string): number {
  return words(text).length;
}
